import React from "react";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useAddShoppingCartItemMutation } from "../../api/shoppingCartApi";
import { cartStateUpdate } from "../../store/reducers/cartSlice";
import { useNavigate } from "react-router-dom";
import { MatchLocationToCurrency } from "../Extensions/MatchLocationToCurrency";
import { addToGuestCart } from "../../store/reducers/guestCartSlice";
import './Styles/PriceSection.css';

const Sidebar = (props) => {
  const [addBasketItem] = useAddShoppingCartItemMutation();
  const dispatch = useDispatch();
  const userDetail = useSelector((state) => state.authStore.nameIdentifier);
  const navigate = useNavigate();

  const addBasket = async () => {
    const courseDetail = props.courseDetail;

    if (userDetail === "") {
      // Guest user - add to guest cart
      dispatch(
        addToGuestCart({
          courseId: courseDetail.courseId,
          courseName: courseDetail.courseName,
          coursePrice: courseDetail.coursePrice,
          courseImage: courseDetail.courseImage,
        })
      );
      toast.success("Item added to guest cart");
      props.onCartAdd && props.onCartAdd();
      return;
    }

    // Authenticated user - add to server cart
    const shoppingCartModel = {
      courseId: courseDetail.courseId,
    };

    const response = await addBasketItem(shoppingCartModel);
    if (response && response.data.isSuccess) {
      dispatch(cartStateUpdate(response.data.result.item2));
      toast.success(response.data.messages[0]);
      props.onCartAdd && props.onCartAdd();
    } else {
      if (response.data.errorMessages.length > 0) {
        toast.error(response.data.errorMessages[0]);
      } else {
        toast.info(response.data.messages[0]);
      }
    }
  };

  return (
    <div className="price-section-balanced">
      <div className="price-card-balanced">
        <div className="price-header">
          <svg className="price-icon-balanced" fill="currentColor" viewBox="0 0 16 16">
            <path d="M4 10.781c.148 1.667 1.513 2.85 3.591 3.003V15h1.043v-1.216c2.27-.179 3.678-1.438 3.678-3.3 0-1.59-.947-2.51-2.956-3.028l-.722-.187V3.467c1.122.11 1.879.714 2.07 1.616h1.47c-.166-1.6-1.54-2.748-3.54-2.875V1H7.591v1.233c-1.939.23-3.27 1.472-3.27 3.156 0 1.454.966 2.483 2.661 2.917l.61.162v4.031c-1.149-.17-1.94-.8-2.131-1.718H4zm3.391-3.836c-1.043-.263-1.6-.825-1.6-1.616 0-.944.704-1.641 1.8-1.828v3.495l-.2-.05zm1.591 1.872c1.287.323 1.852.859 1.852 1.769 0 1.097-.826 1.828-2.2 1.939V8.73l.348.086z"/>
          </svg>
          <span className="price-label-balanced">Kurs Fiyatı</span>
        </div>
        
        <div className="price-display-balanced">
          {props.courseDetail.coursePrice === 0 ? (
            <div className="price-free-balanced">
              <span className="free-text-balanced">Ücretsiz</span>
              <span className="free-badge">🎁 Bedava Kurs</span>
            </div>
          ) : (
            <div className="price-amount-balanced">
              <span className="currency-balanced">{MatchLocationToCurrency()}</span>
              <span className="amount-balanced">{props.courseDetail.coursePrice}</span>
            </div>
          )}
        </div>

        <button className="add-cart-btn-balanced" onClick={addBasket}>
          <svg className="cart-icon-balanced" fill="currentColor" viewBox="0 0 16 16">
            <path d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 13 12H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5zM3.102 4l1.313 7h8.17l1.313-7H3.102zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
          </svg>
          <span>Sepete Ekle</span>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
